// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { LayoutGetString, HeaderGetString, AppchromeGetString, HeaderButtonsControlGetString } from './types.generated'

const layoutLocales = ['en-US'] as const

export const getStringLayout: LayoutGetString = i18nBundle('layout', layoutLocales).getString

const headerLocales = ['en-US'] as const

export const getString: HeaderGetString = i18nBundle('header', headerLocales).getString
export const getStringHeader: HeaderGetString = getString

const appchromeLocales = ['en-US'] as const

export const getStringAppchrome: AppchromeGetString = i18nBundle('appchrome', appchromeLocales).getString

const headerButtonsControlLocales = ['en-US'] as const

export const getStringHeaderButtonsControl: HeaderButtonsControlGetString = i18nBundle('HeaderButtonsControl', headerButtonsControlLocales).getString

